import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DropdownMenu from './DropdownMenu';
import LoginButton from './LoginButton';

const LoginText = ({ toggleModal }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('google_token');
    if (token) {
      setIsLoggedIn(true);
    }
  }, []);

  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleProfileClick = () => {
    navigate('/profile');
    setIsDropdownOpen(false);
  };

  const handleSettingsClick = () => {
    navigate('/settings');
    setIsDropdownOpen(false);
  };

  const handleSignOut = () => {
    setIsLoggedIn(false);
    setIsDropdownOpen(false);
  };

  return (
    <div className="relative">
      <LoginButton
        isLoggedIn={isLoggedIn}
        onClick={handleDropdownToggle}
        toggleModal={toggleModal}
      />
      {isLoggedIn && isDropdownOpen && (
        <DropdownMenu
          onClose={() => setIsDropdownOpen(false)}
          onProfileClick={handleProfileClick}
          onSettingsClick={handleSettingsClick}
          onSignOut={handleSignOut}
        />
      )}
    </div>
  );
};

export default LoginText;
